<div *ngIf="isShown" @fadeInOut class="dialog-container">
  <div (click)="cancel.emit()" class="dialog-background" [class.blur]="blur"></div>

  <div class="dialog" [ngClass]="{'min-width-default': minWidthDefault}" [style.min-width.px]="minWidth" [style.min-height.px]="minHeight" [style.max-width.px]="maxWidth"
    [style.max-height]="maxHeight">
    <div *ngIf="showHeader" class="header-container flex flex-row" [ngClass]="{'hide-underline': hideHeaderUnderline}">

      <img *ngIf="headerIcon === 'warning'" 
      class="pr-3 self-start" [ngClass]="headerIconClasses"
      [src]="'assets/icons/' + headerIconName + '.svg'"/>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" class="pr-5 self-start blue" width="70" height="40" *ngIf="headerIcon === 'info'">
        <rect width="256" height="256" fill="none" />
        <circle cx="128.001" cy="128" r="96" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="12" />
        <polyline fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="12"
          points="120 120 128.001 120 128 176 136 176" />
        <circle cx="128" cy="84" r="10" />
      </svg>

      <div>
        <div *ngIf="header" class="header" [ngClass]="headerCustomClasses">{{header}}</div>
        <div *ngIf="subHeader" class="sub-header">
          <img *ngIf="subheaderIconName" 
            class="pr-1"
            [src]="'assets/icons/' + subheaderIconName + '.svg'"/>
          {{subHeader}}
        </div>
      </div>
      <div *ngIf="hasCloseButton" (click)="closeButtonClicked()">
        <img class="close-icon" src="assets/icons/icon-close-dark-gray.svg" alt="close" 
        />
      </div>
    </div>

    <div class="content" [class.scrollable]="scrollable" cdk-scrollable [style.max-height]="scrollable ? scrollableMaxHeight : 'unset'">
      <ng-content></ng-content>
    </div>

    <div *ngIf="hasControls" class="dialog-controls-default" [ngClass]="{'hide-controls-divider': hideControlsDivider}">
      <app-button class="cancel-btn"
                  subStyle="transparent"
                  [text]="cancelBtnText"
                  (clicked)="cancel.emit()"
                  (keydownTab)="cancelKeydownTab()"
                  #cancelButton
      ></app-button>
      <app-button *ngIf="!hideSaveButton"
                  class="save-btn"
                  [text]="saveBtnText"
                  [disabled]="disableSaveBtn"
                  [minWidth]="saveBtnMinWidth"
                  (clicked)="save.emit()"
                  (keydownTab)="submitKeydownTab()"
                  #submitButton
      ></app-button>
    </div>
  </div>
</div>
